export default {
  type: 'Group',
  label: 'Field Group',
  description: 'A group of fields',
  fields: [
    {
      id: 'id',
      label: 'ID',
      type: 'Text',
      required: true,
      description: 'The unique id of the field.',
    },
    {
      id: 'label',
      label: 'Label',
      type: 'Text',
      required: true,
      description: 'Name displayed in the editor.',
    },
    {
      id: 'expanded',
      label: 'Start Expanded',
      type: 'Boolean',
      description: 'Should this group be expanded by default?',
    },
  ],
}
